<mat-list role="list">
  <mat-list-item 
    role="listitem" 
    class="list_coutrys behavior_lista"
    [class.active-language]="getCurrentLanguage() === 'pt'"
    (click)="changeLanguage('pt')">
    <img class="flag_coutry" alt="Brasil" src="https://purecatamphetamine.github.io/country-flag-icons/3x2/BR.svg"
      width="25" />
    Português
  </mat-list-item>

  <mat-list-item 
    role="listitem" 
    class="list_coutrys behavior_lista"
    [class.active-language]="getCurrentLanguage() === 'es'"
    (click)="changeLanguage('es')">
    <img class="flag_coutry" alt="España" src="https://purecatamphetamine.github.io/country-flag-icons/3x2/ES.svg"
      width="25" />
    Español
  </mat-list-item>

  <mat-list-item 
    role="listitem" 
    class="list_coutrys behavior_lista"
    [class.active-language]="getCurrentLanguage() === 'en'"
    (click)="changeLanguage('en')">
    <img class="flag_coutry" alt="United States" src="https://purecatamphetamine.github.io/country-flag-icons/3x2/US.svg"
      width="25" />
    English
  </mat-list-item>

</mat-list>